import childrens from './views/childrens.js';
export default childrens;
